export default __webpack_public_path__ + "static/tech-rehab-705335eb70ecefd74c2377b65b3c631b.jpg";